import { httpClient } from '@/infra/protocols/http';

export function deleteAttachedFile(params: DeleteAttachedFileService.Params) {
  return httpClient.delete(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}/episodios/${params.episodeId}/roteiro/arquivo/${params.name}`,
  );
}

export namespace DeleteAttachedFileService {
  export interface Params {
    projectId: string;
    podcastId: string;
    episodeId: string;
    name: string;
  }
}
